// extracted by mini-css-extract-plugin
export default {"rt":"RootBoundary_rt__KHCZY","link":"RootBoundary_link__C7T08"};